import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { toanLessons } from '../../mocks/toan-lessons';

const ToanPage = () => {
  const categories = ['Đại số', 'Hình học', 'Giải tích', 'Xác suất thống kê'];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-cyan-50 via-teal-50 to-emerald-50 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img 
              src="https://public.readdy.ai/ai/img_res/e301070e30965ef6f952be092343b517.jpg"
              alt="Toán học background"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="max-w-7xl mx-auto text-center relative z-10">
            <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-function-line"></i>
              <span>Toán Học</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              Toán Học Lớp 6-12
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Hệ thống kiến thức toán học đầy đủ với 2000+ công thức, phương pháp giải nhanh, 
              bài tập có lời giải chi tiết từ cơ bản đến nâng cao
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <a href="#bai-hoc" className="px-8 py-3 bg-cyan-600 text-white rounded-lg font-medium hover:bg-cyan-700 transition-colors whitespace-nowrap cursor-pointer">
                Xem bài học
              </a>
              <a href="#cong-thuc" className="px-8 py-3 bg-white text-cyan-600 rounded-lg font-medium border-2 border-cyan-600 hover:bg-cyan-50 transition-colors whitespace-nowrap cursor-pointer">
                Công thức
              </a>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-12 px-6 bg-white border-b">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-cyan-600 mb-2">{toanLessons.length}+</div>
                <div className="text-gray-600">Bài học</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-cyan-600 mb-2">2000+</div>
                <div className="text-gray-600">Công thức</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-cyan-600 mb-2">5000+</div>
                <div className="text-gray-600">Bài tập</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-cyan-600 mb-2">100%</div>
                <div className="text-gray-600">Có lời giải</div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section id="danh-muc" className="py-16 px-6 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" style={{ fontFamily: 'Merriweather, serif' }}>
              Danh Mục Toán Học
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {categories.map((category, index) => {
                const icons = ['ri-functions', 'ri-shape-line', 'ri-line-chart-line', 'ri-pie-chart-line'];
                const lessonCount = toanLessons.filter(l => l.category === category).length;
                return (
                  <a 
                    key={index}
                    href={`#${category.toLowerCase().replace(/\s+/g, '-')}`}
                    className="group bg-white p-8 rounded-xl border-2 border-gray-200 hover:border-cyan-500 hover:shadow-lg transition-all cursor-pointer"
                  >
                    <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <i className={`${icons[index]} text-white text-2xl`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{category}</h3>
                    <p className="text-sm text-gray-600">
                      {lessonCount > 0 ? `${lessonCount} bài học` : 'Đang cập nhật'}
                    </p>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        {/* Lessons Section */}
        <section id="bai-hoc" className="py-16 px-6 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
                Bài Học Toán Học
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Lý thuyết đầy đủ, công thức chi tiết và phương pháp giải bài tập từ cơ bản đến nâng cao
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {toanLessons.map((lesson) => (
                <article key={lesson.id} className="bg-white rounded-xl border border-gray-200 hover:shadow-xl transition-all overflow-hidden group">
                  <div className="h-48 bg-gradient-to-br from-cyan-100 to-teal-100 relative overflow-hidden">
                    <img 
                      src={`https://readdy.ai/api/search-image?query=clean%20modern%20mathematics%20formulas%20and%20geometric%20shapes%20on%20elegant%20cyan%20teal%20background%20educational%20design%20with%20numbers%20equations%20creating%20scholarly%20atmosphere&width=600&height=400&seq=toan-${lesson.id}&orientation=landscape`}
                      alt={lesson.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 object-top"
                    />
                    <div className="absolute top-4 right-4 bg-cyan-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                      Lớp {lesson.grade}
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                      <span className="bg-cyan-100 text-cyan-700 px-2 py-1 rounded">{lesson.category}</span>
                      <span>•</span>
                      <span><i className="ri-time-line"></i> {lesson.readTime} phút</span>
                      <span>•</span>
                      <span><i className="ri-eye-line"></i> {lesson.views.toLocaleString()}</span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-cyan-600 transition-colors">
                      {lesson.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                      {lesson.excerpt}
                    </p>
                    <a 
                      href={`/toan/${lesson.slug}`}
                      className="inline-flex items-center gap-2 text-cyan-600 font-medium text-sm hover:gap-3 transition-all cursor-pointer"
                    >
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-cyan-600 to-teal-600 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              Chinh Phục Toán Học Ngay Hôm Nay
            </h2>
            <p className="text-xl mb-8 text-cyan-50">
              Nắm vững công thức, phương pháp và đạt điểm cao trong các kỳ thi
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="#bai-hoc" className="px-8 py-4 bg-white text-cyan-600 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Khám phá ngay
              </a>
              <a href="/lien-he" className="px-8 py-4 bg-cyan-700 text-white rounded-lg font-medium hover:bg-cyan-800 transition-colors border-2 border-white/30 whitespace-nowrap cursor-pointer">
                Liên hệ tư vấn
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ToanPage;
